const HiringStageCode = {
  SCREENING: "screeningByTalentTeam",
  SHORTLIST: "shortlist",
  CLIENT_ENDORSEMENT: "clientEndorsement",
  CLIENT_INTERVIEW: "clientInterview",
  CLIENT_INTERVIEW_1: "clientInterview_1",
  CLIENT_INTERVIEW_2: "clientInterview_2",
  CLIENT_INTERVIEW_3: "clientInterview_3",
  CLIENT_INTERVIEW_4: "clientInterview_4",
  TECHNICAL_ASSESSMENT_1: "technicalAssessment_1",
  TECHNICAL_ASSESSMENT_2: "technicalAssessment_2",
  TECHNICAL_ASSESSMENT_3: "technicalAssessment_3",
  TECHNICAL_ASSESSMENT_4: "technicalAssessment_4",
  CULTURAL_INTERVIEW: "culturalInterview",
  OFFER: "offer",
  OFFER_ACCEPTED: "offerAccepted",
  REJECT: "reject",
};

const HiringInterviewCodes = [
  "clientInterview",
  "clientInterview_1",
  "clientInterview_2",
  "clientInterview_3",
  "clientInterview_4",
  "culturalInterview",
];

const FirefliesSummaryStatus = {
  PENDING: "PENDING",
  IN_PROCESS: "IN_PROCESS",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
};

export { FirefliesSummaryStatus, HiringInterviewCodes, HiringStageCode };
